import { GetServerSideProps } from 'next';
import { SETTINGS } from '../config/settings';

import { Hub } from '../modules/hub/Hub';

export default function HubPage() {
  return <Hub />;
}

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  if (SETTINGS.server.maintenance === 'true') {
    return { redirect: { destination: '/maintenance', permanent: false } };
  }

  const { ory_kratos_session, session_token } = req.cookies;

  const hasSession = Boolean(ory_kratos_session) || Boolean(session_token);

  if (hasSession) {
    return {
      redirect: {
        permanent: false,
        destination: '/home',
      },
    };
  }

  return {
    props: {},
  };
};
